import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { DEACTIVATION_REASONS, NOTE_MAX, OTHER_TEXT_MAX, todayEt, validateDeactivation } from '../utils/deactivationReasons';

// Bulk "Set reason" for inactive patients with no recorded reason (Super Admin / Org Manager). Audited server-side.
const SetDeactivationReasonModal = ({ show, count, onCancel, onConfirm, submitting = false }) => {
    const [reasonCode, setReasonCode] = useState('');
    const [reasonText, setReasonText] = useState('');
    const [note, setNote] = useState('');
    const [dateOfDeath, setDateOfDeath] = useState('');

    useEffect(() => {
        if (show) {
            setReasonCode('');
            setReasonText('');
            setNote('');
            setDateOfDeath('');
        }
    }, [show]);

    const error = validateDeactivation({ reasonCode, reasonText, note, dateOfDeath });
    const body = {
        reasonCode,
        ...(reasonCode === 'other' && { reasonText: reasonText.trim() }),
        ...(note.trim() && { note: note.trim() }),
        ...(reasonCode === 'deceased' && dateOfDeath && { dateOfDeath }),
    };

    return (
        <Modal show={show} onHide={onCancel} aria-labelledby="set-reason-title">
            <Modal.Header closeButton>
                <Modal.Title id="set-reason-title" as="h6">Set deactivation reason</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <small style={{ color: 'gray' }}>
                    Applies to {count} selected inactive patient{count === 1 ? '' : 's'} with no recorded reason. Recorded
                    reasons are never overwritten. Each change is recorded in the audit log.
                </small>
                <label htmlFor="set-reason-code" className="mt-2 d-block" style={{ fontSize: '13px' }}>Reason (required)</label>
                <select id="set-reason-code" className="form-control" value={reasonCode} onChange={(e) => setReasonCode(e.target.value)}>
                    <option value="">Select a reason…</option>
                    {DEACTIVATION_REASONS.map((r) => <option key={r.code} value={r.code}>{r.label}</option>)}
                </select>
                {reasonCode === 'other' && (
                    <input
                        aria-label="Describe the reason (required)"
                        type="text"
                        className="form-control mt-2"
                        placeholder="Describe the reason (required)"
                        maxLength={OTHER_TEXT_MAX}
                        value={reasonText}
                        onChange={(e) => setReasonText(e.target.value)}
                    />
                )}
                {reasonCode === 'deceased' && (
                    <>
                        <label htmlFor="set-reason-dod" className="mt-2 d-block" style={{ fontSize: '13px' }}>Date of death (optional)</label>
                        <input id="set-reason-dod" type="date" className="form-control" max={todayEt()} value={dateOfDeath} onChange={(e) => setDateOfDeath(e.target.value)} />
                    </>
                )}
                <label htmlFor="set-reason-note" className="mt-2 d-block" style={{ fontSize: '13px' }}>Note (optional)</label>
                <textarea id="set-reason-note" className="form-control" rows={2} maxLength={NOTE_MAX} value={note} onChange={(e) => setNote(e.target.value)} />
                {reasonCode && error && <div className="text-danger" style={{ fontSize: '12px' }}>{error}</div>}
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-sm btn-secondary" onClick={onCancel}>Cancel</button>
                <button type="button" className="btn btn-sm btn-primary" disabled={!!error || submitting || !count} onClick={() => onConfirm(body)}>
                    Set reason
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default SetDeactivationReasonModal;
